package eu.bontlab.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowRight
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import eu.bontlab.components.PortfolioCard
import eu.bontlab.components.SectionTitle
import eu.bontlab.models.PortfolioItem
import eu.bontlab.models.Section
import eu.bontlab.models.Testimonial
import eu.bontlab.styles.AboutTextStyle
import eu.bontlab.styles.MainImageStyle
import eu.bontlab.styles.PortfolioArrowIconStyle
import eu.bontlab.util.Constants.FONT_FAMILY
import kotlinx.browser.document
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
inline fun <reified T> PortfolioSection(section: Section, testimonial: Testimonial)
        where T : Enum<T>, T : PortfolioItem {

    val sectionId = remember { section.id }

    Box(
        modifier = Modifier
            .id(sectionId)
            .backgroundColor(Color.black)
            .fillMaxWidth()
            //  .maxWidth(SECTION_WIDTH.px)
            .padding(topBottom = 50.px),
        contentAlignment = Alignment.Center
    ) {
        val containerId = remember { "scroll-${T::class.simpleName}-${hashCode()}" }
        val items: List<T> = enumValues<T>().toList()
        PortfolioContent(
            items = items,
            containerId = containerId,
            section = section,
            testimonial = testimonial)
    }
}

@OptIn(DelicateApi::class)
@Composable
fun <T : PortfolioItem> PortfolioContent(
    items: List<T>,
    containerId: String,
    section: Section,
    testimonial: Testimonial
) {
    val breakpoint = rememberBreakpoint()
    Column(
        modifier = Modifier
            .fillMaxWidth(
                if (breakpoint >= Breakpoint.MD) 100.percent
                else 80.percent
            ),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SectionTitle(
            modifier = Modifier
                .fillMaxWidth()
                .margin(bottom = 50.px),
            section = section,
            alignment = Alignment.CenterHorizontally
        )
        AppImage(testimonial.image)
        P(
            attrs = AboutTextStyle.toModifier()
                .margin(bottom = 50.px)
                .maxWidth(800.px)
                .fontFamily(FONT_FAMILY)
                .fontSize(18.px)
                .fontWeight(FontWeight.Normal)
                .fontStyle(FontStyle.Italic)
                .color(Color.goldenrod)
                .toAttrs()
        ) {
            Text(testimonial.review)
        }
        PortfolioCards(breakpoint = breakpoint, items, containerId = containerId)
        PortfolioNavigation(containerId = containerId)
    }
}

@Composable
fun AppImage(image_id: String) {
    Column(
        modifier = Modifier
            .fillMaxSize(60.percent)
            .fillMaxHeight()
            .padding (bottom = 30.px),
        verticalArrangement = Arrangement.Bottom
    ) {

        Image(
            modifier = MainImageStyle.toModifier()
                .fillMaxWidth(),
            src = image_id,
            alt = "Main Image"
        )

    }
}


@Composable
fun <T : PortfolioItem> PortfolioCards(breakpoint: Breakpoint,
    items: List<T>, containerId: String
) {
    Row(
        modifier = Modifier
            .id(containerId)
           // .fillMaxSize()
            .fillMaxHeight()
            .fillMaxWidth(percent = if (breakpoint > Breakpoint.MD) 75.percent
            else if (breakpoint > Breakpoint.SM) 95.px
            else 100.percent)
            .margin(bottom = 50.px)
        /*    .maxWidth(
                if (breakpoint > Breakpoint.MD) 950.px
                else if (breakpoint > Breakpoint.SM) 625.px
                else 300.px
            ) */
            .overflow(Overflow.Hidden)
            .scrollBehavior(ScrollBehavior.Smooth)
    ) {

        items.forEachIndexed { index, portfolio ->
            PortfolioCard(
                breakpoint= breakpoint,
                modifier = Modifier.margin(
                    right = if (index < items.lastIndex) 25.px else 0.px
                ),
                portfolio = portfolio
            )
        }
    }
}

@Composable
fun PortfolioNavigation(containerId: String,) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.Center
    ) {
        FaArrowLeft(
            modifier = PortfolioArrowIconStyle.toModifier()
                .margin(right = 40.px)
                .cursor(Cursor.Pointer)
                .onClick {
                    document.getElementById(containerId)
                        ?.scrollBy(x = (-325.0), y = 0.0)
                },
            size = IconSize.LG
        )
        FaArrowRight(
            modifier = PortfolioArrowIconStyle.toModifier()
                .cursor(Cursor.Pointer)
                .onClick {
                    document.getElementById(containerId)
                        ?.scrollBy(x = 325.0, y = 0.0)
                },
            size = IconSize.LG
        )
    }
}